<main role="main" *ngIf="!viewSplashScreen"
    class="d-flex flex-column h-100 justify-content-between">
    <div>
        <app-header [isPreview]="isPreviewMode" class="no-print"></app-header>
        <div *ngIf="resolveLang && resolveAuth && nodeService.header" class="container-body">
            <router-outlet #outlet="outlet"></router-outlet>
        </div>
    </div>
    <app-footer [ngStyle]="{'display': !isOpenMenu ? 'block' : 'none'}" [isPreview]="isPreviewMode" class="no-print">
    </app-footer>
</main>